import { errorHelpers } from '@approvalmax/utils';
import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import { requestSelector } from 'pages/requestForm/selectors/pageSelectors';
import { getRequestEditMode } from 'pages/requestForm/selectors/requestSelectors';
import { getRuleTypeByEditMode } from 'pages/requestForm/utils/helpers';
import { useEffect, useState } from 'react';
import { useLazyGetNetSuiteVendor } from 'shared/data/webApp/v1';

import { mapVendor } from '../../NetSuiteRequestForm/NetSuiteRequestForm.helpers';

export const useVendorData = (
    currencies: domain.NetSuiteCurrency[],
    vendorId?: string,
    requestId?: string,
    companyId?: string
) => {
    const request = useSelector(requestSelector);
    const editMode = useSelector((state) => getRequestEditMode(state, request));
    const ruleType = getRuleTypeByEditMode(editMode);

    const [triggerGetNetSuiteVendor, { isLoading }] = useLazyGetNetSuiteVendor();

    const [vendorData, setVendorData] = useState<domain.NetSuiteVendor>();

    useEffect(() => {
        const getNetSuiteVendor = async (vendorId: string, requestId: string, companyId: string) => {
            try {
                const { vendor } = await triggerGetNetSuiteVendor({
                    params: {
                        query: {
                            requestId,
                            companyId,
                            vendorInternalId: vendorId,
                            ruleType,
                        },
                    },
                });

                setVendorData(mapVendor(vendor, currencies) ?? undefined);
            } catch (error) {
                errorHelpers.captureException(error);
            }
        };

        if (vendorId && requestId && companyId) {
            void getNetSuiteVendor(vendorId, requestId, companyId);
        }
    }, [vendorId, requestId, companyId, currencies, ruleType, triggerGetNetSuiteVendor]);

    return {
        vendorData,
        isLoading,
    };
};
